import '../../styles/Layout.css';
import Header from "./Header.jsx";
import Footer from "../Footer.jsx";



function LayoutComponent(props) {
    const {children,headerHidden} = props;
    return (
        <div className={"container"}>
            <header>
                <Header headerHidden={headerHidden}/>
            </header>
            <div className="container-body">
                {children}

            </div>
            <Footer/>
        </div>
    )
}

export default LayoutComponent;